export const eventTimeFormat = {
  hour: 'numeric',
  minute: '2-digit',
  omitZeroMinute: false,
  meridiem: 'narrow',
  hour12: false,
};

export const slotLabelFormat = {
  hour: 'numeric',
  minute: 'numeric',
  omitZeroMinute: false,
  hour12: false,
};

export const deleteModalText = {
  titleText: 'Apakah kamu yakin ingin menghapus jadwal ini?',
  contentDesctText: 'Tindakan ini tidak bisa dibatalkan, dan semua detail terkait akan hilang.',
  primaryButtonText: 'Hapus sekarang',
  secondaryButtonText: 'Batal',
};
